import { takeLatest, all, select, put, call } from 'redux-saga/effects';
import { getFirebase } from 'react-redux-firebase';
import { makeSelectSavedResources } from 'containers/Resources/selectors';
import { maybeContentfulReviewStatus } from 'utils/api';
import ctf from 'utils/contentfulService';
import { getContentfulLocaleFilter } from 'containers/Main/utils';
import {
  GET_SAVED_BEST_RESOURCES,
  GET_FAVORITE_PUBLIC_LISTS,
} from './constants';
import {
  processing,
  getSavedBestResourcesSuccess,
  getFavoritePublicListsSuccess,
} from './actions';

function* getSaveBestResourcesSaga() {
  try {
    yield put(processing(true));
    const userID = yield getFirebase().auth().currentUser.uid;
    const savedResources = yield getFirebase()
      .firestore()
      .collection('user_resources')
      .doc(userID)
      .collection('saved_best_resources')
      .get();
    const bestResources = savedResources.docs.map(doc => doc.data());
    const response = yield all(
      bestResources.map(async ({ topicSlug, type }) => {
        try {
          const resources = await getFirebase()
            .firestore()
            .collection('best_resources')
            .doc(topicSlug)
            .collection(type)
            .doc(`best-${type}`)
            .get();
          return { type, resourceData: resources.data(), topicSlug };
        } catch (error) {
          return null;
        }
      }),
    );
    yield put(getSavedBestResourcesSuccess(response));
  } catch (error) {
    yield put(getSavedBestResourcesSuccess([]));
  } finally {
    yield put(processing(false));
  }
}

function* getFavoritePublicListsSaga() {
  try {
    const resources = yield select(makeSelectSavedResources());
    const localeFilters = yield call(getContentfulLocaleFilter);
    const publicListsIDs = resources
      .filter(el => el.type === 'Lists')
      .map(el => el.resourceID);

    const response = yield ctf.getEntries({
      content_type: 'list',
      'sys.id[in]': publicListsIDs.join(','),
      ...maybeContentfulReviewStatus(),
      ...localeFilters,
    });
    yield put(getFavoritePublicListsSuccess(response.items));
  } catch (error) {
    yield put(getFavoritePublicListsSuccess([]));
  }
}

// Individual exports for testing
export default function* defaultSaga() {
  yield takeLatest(GET_SAVED_BEST_RESOURCES, getSaveBestResourcesSaga);
  yield takeLatest(GET_FAVORITE_PUBLIC_LISTS, getFavoritePublicListsSaga);
}
